import styled from "styled-components";

export const StyledCard = styled.div`
  margin: auto;
  margin-top: 30vh;
  margin-bottom: 60vh;
`;

export const StyledCardHeader = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  border-bottom: 1px solid #000;
`;
